import React from 'react';
import {Link} from "react-router-dom";
import * as queryString from "query-string";

const SsoUserEmailButton = ({ email }) => {
    const query = Object.assign({
        page: 1,
        email: email,
        cQw08la1wX: new Date().getTime(),
        target: 'email'
    });

    return (
        <Link to={`/query/ebadges?${queryString.stringify(query)}`}>{email}</Link>
    )
};

export default SsoUserEmailButton;



// WEBPACK FOOTER //
// ./src/components/sso/SsoUserEmailButton.js